import React from 'react';
import styles from './toggle.module.less'

const Toggle = ({ checked, onChange }) => (
  <span className={styles.toggleControl}>
    <input
      className={styles.dmcheck}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      id="dmcheck"
    />
    <label htmlFor="dmcheck"  aria-label="Click to toggle between dark/light modes"/>
  </span>
);

export default Toggle;
